import {
  Wallet, TrendingUp, Building2, Landmark, Briefcase, PiggyBank,
  Apple, Wrench, Fuel, Stethoscope, Lightbulb, Phone, Shirt, Gift, Film,
  Scissors, Plane, GraduationCap, Users, Shield, HeartPulse, Car,
  Home as HomeIcon, CreditCard, MoreHorizontal, FileText, UserCheck, Heart, Award, Star,
  HandHeart, BookOpen
} from "lucide-react";

export const incomeIcons = {
  "Salary Income": Wallet,
  "Salary Income – Self": UserCheck,
  "Salary Income – Spouse": Heart,
  "Bonus/Incentive – Self": Award,
  "Bonus/Incentive – Spouse": Star,
  "Business Income": Briefcase,
  "Rental Income": Building2,
  "Interest Income": Landmark,
  "Investment Income": TrendingUp,
};

export const expenseIcons = {
  "Food & Grocery": Apple,
  "House Rent / Maintenance / Repair": Wrench,
  "Conveyance, Fuel & Maintenance": Fuel,
  "Medicines / Doctor / Healthcare": Stethoscope,
  "Electricity / Water / Labour / AMCs": Lightbulb,
  "Mobile / Telephone / Internet": Phone,
  "Clothes & Accessories": Shirt,
  "Shopping/Gifts/Electronics": Gift,
  "Dining/Movies/Sports": Film,
  "Personal Care/Others": Scissors,
  "Travel & Annual Vacations": Plane,
  "Children's Schooling/College": GraduationCap,
  "Contribution to Parents/Siblings": Users,
  "Life Insurance Term": Shield,
  "Mediclaim/PA/CI": HeartPulse,
  "Motor/General Insurance": Car,
  "Home Loan EMI": HomeIcon,
  "Car Loan EMI": Car,
  "Personal Loan EMI": CreditCard,
  "Other Expenses": MoreHorizontal,
  "Charity/Donation": HandHeart,
  "Learning/Self-Development": BookOpen,
};

export const savingsIcons = {
  "PPF / SSY": PiggyBank,
  "Recurring Deposits (RDs)": Landmark,
  "Insurance Premiums (savings plans)": Shield,
  "Mutual Fund SIPs": TrendingUp,
  "Government savings schemes": FileText,
};
